import { render, staticRenderFns } from "./NDialog.vue?vue&type=template&id=077af769"
import script from "./NDialog.vue?vue&type=script&lang=js"
export * from "./NDialog.vue?vue&type=script&lang=js"
import style0 from "./NDialog.vue?vue&type=style&index=0&id=077af769&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports